module.exports = __webpack_public_path__ + "static/img/bkg-circle.771888ba.png";